module.exports = __webpack_public_path__ + "img/Tablet - 62.cc2cd72c.png";